/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import {
	SET_ANALYTICS_OPTIN,
	SET_LEFTNAV_OPEN,
	SET_FORCE_HIDE_MENU,
	SET_FORCE_HIDE_NAVBAR,
	SET_LANGUAGE,
	SET_FORCE_HIDE_LANGUAGE_SWITCHER,
	SET_FORCE_HIDE_LEARN_HOME,
	SET_MAIN_CONTAINER_OVERLAY,
	SET_BACKGROUND_HOME,
} from '../types';

/* eslint-disable space-before-function-paren */

export const setAnalyticsOptinInited = (value: boolean) => (dispatch: Function) => {
	dispatch({
		type: SET_ANALYTICS_OPTIN,
		analyticsOptinInited: value,
	});
};

export const setLeftNavOpen = (value: boolean) => (dispatch: Function) => {
	dispatch({
		type: SET_LEFTNAV_OPEN,
		leftNavOpen: value,
	});
};

export const setForceHideMenu = (value: boolean) => (dispatch: Function) => {
	dispatch({
		type: SET_FORCE_HIDE_MENU,
		forceHideMenu: value,
	});
};

export const setForceHideNavbar = (value: boolean) => (dispatch: Function) => {
	dispatch({
		type: SET_FORCE_HIDE_NAVBAR,
		forceHideNavbar: value,
	});
};

export const setForceHideLanguageSwitcher = (value: boolean) => (dispatch: Function) => {
	dispatch({
		type: SET_FORCE_HIDE_LANGUAGE_SWITCHER,
		forceHideLanguageSwitcher: value,
	});
};

export const setForceHideLearnHome = (value: boolean) => (dispatch: Function) => {
	dispatch({
		type: SET_FORCE_HIDE_LEARN_HOME,
		forceHideLearnHome: value,
	});
};

export const setLanguage = (value: string) => (dispatch: Function) => {
	dispatch({
		type: SET_LANGUAGE,
		langCookie: value,
	});
};

export const setMainContainerOverlay = (value: boolean) => (dispatch: Function) => {
	dispatch({
		type: SET_MAIN_CONTAINER_OVERLAY,
		mainContainerOverlayEnabled: value,
	});
};

export const setBackgroundHome = (value: Object) => (dispatch: Function) => {
	dispatch({
		type: SET_BACKGROUND_HOME,
		backgroundHome: value,
	});
};
/* eslint-enable space-before-function-paren */
